import React from "react";
import DashboardTitle from "./DashboardTitle";
import Cookies from "universal-cookie";
import moment from "moment";
import 'moment/locale/it';
import SelectInput from "./SelectInput";
import FixButton from "./Button";
import getDataForExcelAgente from "../services/getDataForExcelAgente";
import XLSX from 'sheetjs-style';
import FileSaver from 'file-saver';
import getCommessa from "../services/getCommessa";
import getAgente from "../services/getAgente";
import ReactLoading from 'react-loading';

const cookies = new Cookies();
const username = cookies.get('username', { path: '/' });
const token = cookies.get('token', { path: '/' });
export default class SelectAgentiDate extends React.Component {
    constructor(props) {
        super(props);

        this.months = [];
        var startDate = '2022-01-01';

        moment().locale('it');
        while (moment(startDate, 'yyyy-MM-DD').isSameOrBefore(moment())) {

            let start = moment(startDate, 'yyyy-MM-DD').startOf('month').format('yyyy-MM-DD');
            let end = moment(startDate, 'yyyy-MM-DD').endOf('month').format('yyyy-MM-DD');

            this.months.push({ value: start + ';' + end, label: moment(startDate, 'yyyy-MM-DD').format('MMMM YYYY')});
            startDate = moment(startDate, 'yyyy-MM-DD').add(1, 'month');
        }

        let currentStart = moment().startOf('month').format('yyyy-MM-DD');
        let currentEnd = moment().endOf('month').format('yyyy-MM-DD');
        let month = moment().format('MMMM YYYY');
        
        this.state = {
            meseSelezionato: { value: currentStart + ';' + currentEnd, label: month }, 
            isLoading: false,
        };
    }

    async generaExcel() {

        this.setState({ isLoading: true });

        let res = await getDataForExcelAgente(
            username,
            token,
            this.props.agente,
            this.state.meseSelezionato.value.split(';')[0],
            this.state.meseSelezionato.value.split(';')[1]);
        if (res.result === 'KO') {
            alert(res.error ? res.error : 'Errore durante la generazione dei dati per l\'Excel');
            this.setState({ isLoading: false });
            return;
        }

        let fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let extension = '.xlsx';
        var jsonData = [];

        // Popolo il json
        var i = 0;
        for (const commessa of res.commesse) {

            let comm = await getCommessa(username, token, commessa);
            jsonData.push({
                'Riferimento': comm.rif, 
                'Cantiere': comm.cantiere, 
                'Data ordine': comm.data_ordine, 
                'Data consegna': comm.data_consegna, 
                '': '', 
                'Importo': res.totali[i]
            });
            
            i++;
        }

        jsonData.push({ 'Riferimento': '', 'Cantiere': '', 'Data ordine': '', 'Data consegna': '', '': '', 'Importo': '' })
        jsonData.push({
            'Riferimento': '',
            'Cantiere': '', 
            'Data ordine': '', 
            'Data consegna': '', 
            '': 'Totale mese:', 
            'Importo': res.totale_generale
        });

        let agente = await getAgente(username, token, this.props.agente);

        const ws = XLSX.utils.json_to_sheet(jsonData);
        const wb = { Sheets: { 'data' : ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, agente.ragione_sociale.replace(/ /g, '_') + '_' + this.state.meseSelezionato.label.replace(/ /g, '') + extension);
        
        this.setState({ isLoading: false });

        if (this.props.onEnd) {
            this.props.onEnd();
        }
    }

    render() {

        return(
            <div style={backView} onClick={(e) => this.props.onEnd()}>
                <div style={importView} onClick={(e) => e.stopPropagation()}>
                    { this.state.isLoading ? (
                        <ReactLoading type={'bubbles'} color={'#5cb500'} height={100} width={100} />
                    ) : (
                        <>
                            <DashboardTitle icon={require('../images/import.png')} title={"Seleziona il mese"} />
                            <div style={{ height: 10 }} />
                            <SelectInput
                                key={Math.random()}
                                value={this.state.meseSelezionato} 
                                name={""} 
                                options={this.months} 
                                onChange={(option) => {
                                    this.setState({ meseSelezionato: option });
                                }}
                            />
                            <div style={{ height: 10 }} />
                            <FixButton title={'Genera Excel'} callback={() => this.generaExcel()} />
                        </>
                    )}
                </div>
            </div>
        );
    }
}

const backView = {
    backgroundColor: '#00000033', 
    width: '100%', 
    height: '100%', 
    position: 'absolute', 
    display: 'flex', 
    flexDirection: 'row', 
    alignItems: 'center', 
    justifyContent: 'center',
    top: 0, 
    left: 0, 
}

const importView = {
    backgroundColor: 'white', 
    boxShadow: '0px 2px 10px lighgrey', 
    borderRadius: 15, 
    padding: 30, 
    width: '375px',
}